import { Component } from 'preact';

export default class Wheel extends Component {
  state = {
    visible: false
  }

  componentWillMount () {
    const { fadeIn, visible } = this.props;

    if (fadeIn && visible) {
      setTimeout(() => this.setState({ visible: true }), fadeIn);
    }

    else {
      this.setState({ visible });
    }
  }

  componentWillReceiveProps ({ visible }) {
    if (visible !== this.state.visible) {
      this.setState({ visible });
    }
  }

  rotatePoint (radius = 0, angle = 0, offset = 0) {
    return [
      Math.round(Math.sin(angle) * radius + offset),
      Math.round(Math.cos(angle) * radius + offset)
    ];
  }

  renderWedges (radius, segments) {
    const n = segments.length;
    const angle = Math.PI * 2 / n;
    const imageWidth = Math.round(radius * 0.38);
    const imageHeight = imageWidth;
    const pieCoords = [];
    const imageCoords = [];

    if (n === 1) {
      pieCoords.push([radius, radius]);
      imageCoords.push([radius, radius]);
    }

    else {
      for (let i = 0; i < n; i++) {
        pieCoords.push(this.rotatePoint(radius, angle * i - angle / 2, radius));
        imageCoords.push(this.rotatePoint(radius * 0.58, angle * i, radius));
      }
    }

    return [
      ...pieCoords.map(([x1, y1], i) => {
        let background;

        if (n === 1) {
          background = <circle class="background" r={ radius } cx={ x1 } cy={ y1 } fill="#04B6E6" />;
        }

        else {
          // Fnd next point; if this is the last coord, use first point
          const [x2, y2] = pieCoords[i + 1 === n ? 0 : i + 1];

          background = <path class="background" d={
            `M${radius},${radius} L${x1},${y1} A50,50 0 0 0 ${x2},${y2}`
          } />;
        }

        const [ imageX, imageY ] = imageCoords[i];
        const { key, char, valueGroup } = segments[i];

        return <g class="wedge" key={ key } data-key={ key } data-value={ valueGroup }>
          { background }

          <text class="icon" font-size={ imageWidth } text-anchor="middle" x={ imageX } y={ imageY + imageHeight / 2 }>{ char }</text>
        </g>;
      }),

      <path class="lines" stroke="white" stroke-width="0.5" fill="none" d={
        pieCoords.map(coords =>
          `M${radius},${radius} L${coords.join(',')}`
        ).join(' ')
      } />
    ];
  }

  render (props, state) {
    const { visible } = state;
    const { radius, segments } = props;
    
    if (!segments.length) {
      return null;
    }

    return <svg class={`Wheel${visible ? ' visible' : ''}`} viewBox="0 0 162 100">
      <g class="target">
        <circle class="target-outer" r="3.5%" cx="156" cy="50" fill="none" stroke="white" stroke-width="1%" />
        <circle class="target-inner" r="1.75%" cx="156" cy="50" fill="white" />
        <path class="pointer" d="M70,5 v90 l86,-45z" fill="rgba(127,127,127,0.4)" />
      </g>

      { this.renderWedges(radius, segments) }
    </svg>
  }
}



// WEBPACK FOOTER //
// ./components/Wheel.js